import React from 'react';
import { string, func, bool } from 'prop-types';
import { ButtonNormalLink } from './BookDemoButton.style';

const BookDemoButton = ({
    content,
    maxWidth,
    minWidth,
    color,
    margin,
    width,
    fontSize,
    padding,
    minHeight,
    shadow,
    doStuff,
    swapColorOnOver
}) => {

    return (
        <ButtonNormalLink
            width={width}
            maxwidth={maxWidth}
            minwidth={minWidth}
            color={color}
            margin={margin}
            fontSize={fontSize}
            minheight={minHeight}
            padding={padding}
            shadow={shadow}
            onClick={doStuff}
            swapColorOnOver={swapColorOnOver}
        >
            {content}
        </ButtonNormalLink>
    );
};

BookDemoButton.propTypes = {
    content: string.isRequired,
    maxWidth: string,
    minWidth: string,
    color: string,
    margin: string,
    width: string,
    fontSize: string,
    minHeight: string,
    padding: string,
    shadow: string,
    doStuff: func,
    swapColorOnOver: bool
};

BookDemoButton.defaultProps = {
    minWidth: '',
    color: '#69b643',
    margin: '0',
    width: '',
    fontSize: '14px',
    minHeight: 'unset',
    padding: '17px 23px',
    shadow: 'unset',
    shadowHoverColor: '0 0 23px rgba(117, 203, 75, 0.6)',
    swapColorOnOver: true
};

export default BookDemoButton;